import React from 'react';
import HelpIcon from '@mui/icons-material/HelpOutlineOutlined';

import { TooltipIconButton } from '@paragon/client-tools';
import { DistanceField } from '@paragon/material';
import { humanCase } from '@paragon/utilities';

import { DistanceConfiguration } from '../properties';
import { PropertyComponentProps } from './ModelProperty';

export function DistancePropertyComponent(props: PropertyComponentProps<number | null, DistanceConfiguration>) {
  return (
    <>
      <DistanceField
        label={humanCase(props.name)}
        disabled={props.schema.configuration.readOnly || props.configuration.disabled}
        {...props.schema.configuration.inputProps}
        value={props.value}
        canBeNull={!props.schema.configuration.required}
        canSubmitWhenNull={!props.schema.configuration.required}
        onSubmit={(value) => props.onEdit(value)}
      />
      {props.schema.configuration.helpButtonTooltip && (
        <TooltipIconButton sx={{ ml: 1 }} title={props.schema.configuration.helpButtonTooltip}>
          <HelpIcon />
        </TooltipIconButton>
      )}
    </>
  );
}
